var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',[_c('strong',[_vm._v(" تمام حقوق و امتیاز سایت متعلق به تیم بیتا ایده می باشد ")]),_vm._v("© ۱۳۹۹ "+_vm._s(_vm.$appVersion))])])}
var staticRenderFns = []

export { render, staticRenderFns }